var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notification alert",class:_vm.classes},[_c('div',{staticClass:"media"},[_c('icon',{attrs:{"icon":_vm.icon}}),_vm._v(" "),_c('div',{staticClass:"media-body"},[_vm._v("\n            "+_vm._s(_vm.notification.message)+"\n        ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4b5cb7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Notification.vue
// module id = fAmf
// module chunks = 0